// import './index.css'
import React from 'react'
import {Auth} from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared'
import sb from '@/utils/sb';


const SBApp: React.FC = () => {

    const supabase = sb;
    return <Auth supabaseClient={supabase} appearance={{ theme: ThemeSupa }} />
    // return <div>11</div>
};

export default SBApp;
// export default function Index() {
//     const {user, isAuthenticated, isLoading, logout, loginWithRedirect} = useAuth0();

//   console.log(user,isAuthenticated);

//   if (isLoading) {
//     return <div>Loading ...</div>;
//   }

//   if(!isAuthenticated){
//     return <button onClick={() => loginWithRedirect()}>Log In</button>
//   }

//     return (
//     isAuthenticated && (
//       <div>
//           {/*// @ts-ignore*/}
//         <h2>{user.name}</h2>
//           {/*// @ts-ignore*/}
//         <p>{user.email}</p>
//         <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
//           Log Out
//         </button>
//       </div>
//     )
//   );
  // console.log(14, supabase);
  // const [session, setSession] = useState()
  //
  // useEffect(() => {
  //   supabase.auth.getSession().then(({ data: { session } }) => {
  //     setSession(session)
  //   })
  //
  //   const {
  //     data: { subscription },
  //   } = supabase.auth.onAuthStateChange((_event, session) => {
  //     setSession(session)
  //   })
  //
  //   return () => subscription.unsubscribe()
  // }, [])
  //
  // if (session) {
  //   return (<div>Logged in!</div>)
  // }
  //
  // return (
  //   <div>
  //     <Auth supabaseClient={supabase} appearance={{ theme: ThemeSupa }} />
  //   </div>
  // )
